import Snappy from "../../../libs/snappy/snappy";

Snappy.Component.EduPostLoginDrd = class EduPostLoginDrd extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-post-login-drd';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.isOpened = false;
        this.$opener = this.$element.find('.js-edu-post-login-drd-opener');
        this.$disclaimerTrigger = this.$element.find('.js-edu-post-login-drd-disclaimer')
    }

    setEventListeners() {
        this.$opener.on('click', this.toggle.bind(this));
        this.$body.on('click', this.bodyClickHandle.bind(this));
        this.$disclaimerTrigger.on('click', this.disclaimerClickHandle.bind(this));
    }

    toggle() {
        this[this.isOpened ? 'close' : 'open']();
    }

    open() {
        this.$element.addClass('is-opened');
        this.isOpened = true;

    }

    close() {
        this.$element.removeClass('is-opened');
        this.isOpened = false;
    }

    bodyClickHandle(e) {
        const $target = $(e.target);
        if (this.isOpened && !$target.closest('[data-edu-post-login-drd]').length) {
            this.close();
        }
    }

    disclaimerClickHandle(e) {
        e.preventDefault();
        this.close();
        this.$window.trigger('profileDisclaimer:open');
    }


};



// WEBPACK FOOTER //
// ./components/edu-post-login-drd/scripts/edu-post-login-drd.js